import StdForm from '@shared/components/forms/auto-form/std-form/std-form.vue';
import { Component, Prop } from 'vue-property-decorator';
import EntityTableProvider from '@shared/components/tables/entity-table-provider/entity-table-provider.vue';
import EntityTable from '@shared/components/tables/entity-table/entity-table.vue';
import BpcPageTitle from '@shared/layouts/components/page-title/page-title.vue';
import EntityDeleteModalProvider from '@shared/components/modals/entity-delete-modal-provider/entity-delete-modal-provider.vue';
import ConfirmationModal from '@shared/components/modals/confirmation-modal/confirmation-modal.vue';
import { mixins } from 'vue-class-component';
import AbstractTable from '@shared/components/tables/abstract-table/abstract-table';
import StdFilter from '@shared/components/filters/std-filter/std-filter.vue';
import DrawerModal from '@shared/components/modals/drawer-modal/drawer-modal.vue';
import { CustomFilter } from '@tools/interfaces/custom-filter';

@Component({
  name: 'bpc-custom-filter-table',
  components: {
    'bpc-entity-table-provider': EntityTableProvider,
    'bpc-entity-table': EntityTable,
    'bpc-page-title': BpcPageTitle,
    'bpc-entity-delete-modal-provider': EntityDeleteModalProvider,
    'bpc-confirmation-modal': ConfirmationModal,
    'bpc-std-form': StdForm,
    'bpc-std-filter': StdFilter,
    'bpc-drawer-modal': DrawerModal,
  },
})
export default class CustomFilterTable extends mixins(AbstractTable) {
  @Prop(String) readonly title: string;
  @Prop(String) readonly subtitle: string;

  public entity: CustomFilter = null;
  public entityName = 'custom-filter';
  public pluralEntityName = 'custom-filters';
  public permissionEntityNameToUse = 'custom_filter';

  public flagsToCheckBeforeLoadEntities: string[] = [
    'configLoaded',
    'paginationLoaded',
    'orderLoaded',
    'urlParametersLoaded',
  ];

  // public customPageActions = {};
  // public customRowActions = {};

  constructor() {
    super();
  }

  /* Lifecycle hooks */

  // created() { }
  // mounted() {}
  // updated () { }
  // destroyed () { }
}
